import React from "react";

const BrandRow = ({ index, brand, setShowBrandDeleteModal, setModalData }) => {
  const { brand_name, brand_image, brand_slug } = brand;
  const handleShowModel = () => {
    setModalData(brand);
    setShowBrandDeleteModal(true);
  };
  return (
    <tr>
      <th>{index + 1}</th>
      <td>
        <div class="avatar">
          <div class="w-24 mask mask-squircle">
            <img src={brand_image} alt="brand_image" />
          </div>
        </div>
      </td>
      <td>{brand_name}</td>
      <td>{brand_slug}</td>
      <td>
        <label
          onClick={handleShowModel}
          for="my-modal"
          className="btn btn-sm btn-secondary"
        >
          Delete
        </label>
      </td>
    </tr>
  );
};

export default BrandRow;
